<template>
  <VModalWidget :dismiss="dismiss">
    <template slot="title">{{ title }}</template>

    <template slot="footer-actions">
      <v-btn depressed color="error" @click="doDelete" :loading="loading" :disabled="!hasSelected || loading">{{
        $t('delete')
      }}</v-btn>
      <v-btn depressed color="accent" @click="doRestore" :loading="loading" :disabled="!hasSelected || loading">{{
        $t('restore')
      }}</v-btn>
    </template>

    <template slot="content" v-if="dataLoading">
      <v-loading />
    </template>

    <template slot="content" v-else>
      <FormErrors :show="showResourceErrors" :errors="resourceErrors" />
      <v-data-table
        flat
        v-model="selected"
        :headers="headers"
        :items="items"
        :item-key="itemKey"
        hide-default-footer
        show-select
        class="elevation-0"
      >
      </v-data-table>
    </template>
  </VModalWidget>
</template>

<script>
import { BaseForm, FormErrors, VModalWidget, VLoading } from '@argon/app/components'
export default {
  name: 'RestoreWidget',
  extends: BaseForm,
  components: { VModalWidget, FormErrors, VLoading },
  props: {
    title: { type: String, default: 'Title' },
    restore: { type: Function, required: true },
    delete: { type: Function, required: true },
    dismiss: { type: Function, required: true },
    dataLoading: { type: Boolean, default: false },
    itemKey: { type: String, default: 'id' },
    items: { type: Array, default: () => [] },
    headers: {
      type: Array,
      default: () => [{ text: 'Name', value: 'display' }]
    }
  },
  data: () => ({
    pagination: {
      sortBy: 'name'
    },
    selected: [],
    loading: false
  }),
  computed: {
    hasSelected() {
      return this.selected.length > 0
    }
  },
  methods: {
    doRestore() {
      return this.doAction()
    },
    doDelete() {
      return this.doAction(true)
    },
    doAction(del) {
      let callback = del ? this.delete : this.restore
      this.loading = true
      this.resetServerErrors()
      callback(this.selected)
        .then(() => {
          this.dismiss()
        })
        .catch(this.setServerErrors)
        .finally(() => {
          this.loading = false
        })
    }
  }
}
</script>

<i18n>
{
  "en": {
    "delete": "@:labels.delete",
    "restore": "@:labels.restore"
  },
  "fr": {
    "delete": "@:labels.delete",
    "restore": "@:labels.restore"
  }
}
</i18n>
